import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpService } from '../http/http.service';
import {Payout} from '../../interface';
@Injectable({
  providedIn: 'root'
})
export class PayoutService {
  constructor(private http: HttpService) { }

  public getAll(): Promise<Payout[]> {
    return firstValueFrom(this.http.get('/Payouts/List'));
  }
    public get(id:number): Promise<Payout> {
    return firstValueFrom(this.http.get('/Payouts/'+id));
  }

  public create(data): Promise<Payout> {
    return firstValueFrom(this.http.post('/Payouts', data));
  }
  
  public update(id:number,data): Promise<Payout> {
    return firstValueFrom(this.http.patch('/Payouts/',id, data));
  }
  
  public delete(id:number): Promise<Payout> {
    return firstValueFrom(this.http.delete('/Payouts/',id));
  }

}
